import styled from "styled-components";

import { ASC, DESC } from "app/components/React/Table/Utils/sort";
import { translate } from "app/filters/i18nFilter";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";
import type { OrderBy } from "../types";

import { Header, TERM } from "./Header";

const Container = styled(FlexRow)`
    padding: 0px 56px 8px 48px;
    justify-content: space-between;
    margin-bottom: 8px;
`;

export const Headers = () => {
    const { keywords, orderBy, changeSorting } = useKeywordListComposerContext();
    const { sortDirection, field } = orderBy;
    const setOrderByHOF = (field: OrderBy["field"]) => () => {
        changeSorting({
            field,
            sortDirection: field === orderBy.field ? (sortDirection === ASC ? DESC : ASC) : ASC,
        });
    };
    return (
        <Container>
            <Header
                orderBy={orderBy}
                onClick={setOrderByHOF(TERM)}
                text={translate("auto.keyword.list.generator.body.list.headers.term", {
                    count: keywords.length,
                })}
                isSorted={field === TERM}
            />
            <Header
                orderBy={orderBy}
                onClick={setOrderByHOF("volume")}
                text={translate("auto.keyword.list.generator.body.list.headers.volume")}
                isSorted={field === "volume"}
            />
        </Container>
    );
};
